import getOwnersByParzInfo from '../logic/getOwnersByParzInfo'
import createWindowContent from '../logic/createWindowContent'

const addClickListener = (data, map, infowindow) => {
  map.data.addListener('click', (event) => {
    console.clear()
    map.data.revertStyle()
    map.data.overrideStyle(event.feature, { fillOpacity: 1 })

    const owners = getOwnersByParzInfo(
      data,
      event.feature.getProperty('GSTNR'),
      'grundstueck-nr'
    )

    if (owners[0]) {
      const content = {
        name: [],
        street: [],
        parzNr: [],
        ownerCode: []
      }

      owners.forEach((element, index) => {
        if (index === 0) {
          content.name.push([
            [`${element.vorname} ${element.nameeigentuemer}, ${element.ort}`],
            [element.ownerhash]
          ])

          content.ownerCode.push(element['eigentuemer-code'])

          content.street.push(
            `${element.parzadresse} ${element.parzhausnummer} ${
              element.parzart
            }`
          )
          content.parzNr.push(element['grundstueck-nr'])
        }

        if (index > 0 && element.ownerhash !== owners[index - 1].ownerhash) {
          content.name.push([
            [`${element.vorname} ${element.nameeigentuemer}, ${element.ort}`],
            [element.ownerhash]
          ])

          content.ownerCode.push(element['eigentuemer-code'])

          content.street.push(
            `${element.parzadresse} ${element.parzhausnummer} ${
              element.parzart
            }`
          )
          content.parzNr.push(element['grundstueck-nr'])
        }
      })

      // consctruct html-string for infowindow
      const windowContent = createWindowContent(content)

      // set position of infowindow by pos of event
      infowindow.setPosition(event.latLng)
      infowindow.setContent(windowContent)

      infowindow.open(map)
    } else {
      infowindow.close()
    }
  })
}

export default addClickListener



// WEBPACK FOOTER //
// ./src/mapSetup/addClickListener.js